import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';

import { sciences } from '@marketing/data/sciences';
import { fadeUp, revealOnView, stagger } from '@marketing/motion/variants';

// ============================================================
// ScienceBlock — referências DOI em timeline vertical
// ============================================================

export function ScienceBlock() {
  return (
    <section
      id="ciencia"
      className="lume-section lume-section--alt"
      aria-labelledby="science-title"
    >
      <div className="lume-container">
        <motion.header
          {...revealOnView}
          variants={stagger(0.08)}
          className="lume-stack lume-stack-md"
          style={{ marginBottom: 'clamp(2rem, 4vw, 3rem)', maxWidth: '52rem' }}
        >
          <motion.p variants={fadeUp} className="lume-eyebrow">Ciência por trás</motion.p>
          <motion.h2 variants={fadeUp} id="science-title" className="lume-h2 lume-text-balance">
            Cada decisão UX e clínica do Lume é fundamentada em literatura
          </motion.h2>
          <motion.p variants={fadeUp} className="lume-body-lg lume-text-pretty">
            O programa rejeita gamificação clássica, adota linguagem identidade-primeiro,
            implementa predição on-device com calibração pessoal e usa IA com salvaguardas
            declarativas — tudo respaldado por evidência.
          </motion.p>
        </motion.header>

        <motion.ol
          {...revealOnView}
          variants={stagger(0.06)}
          style={{
            listStyle: 'none',
            padding: 0,
            margin: 0,
            display: 'grid',
            gap: '1rem',
          }}
        >
          {sciences.map((s) => (
            <motion.li
              key={s.id}
              variants={fadeUp}
              className="lume-card"
              style={{ display: 'grid', gap: '1rem' }}
            >
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'minmax(80px, 110px) 1fr',
                  gap: 'clamp(1rem, 2vw, 1.5rem)',
                  alignItems: 'start',
                }}
              >
                <div>
                  <div
                    style={{
                      fontFamily: 'var(--font-display)',
                      fontSize: '2rem',
                      fontWeight: 700,
                      color: 'var(--color-warm-700)',
                      lineHeight: 1,
                    }}
                  >
                    {s.year}
                  </div>
                  <div
                    style={{
                      marginTop: '0.5rem',
                      fontSize: '0.8rem',
                      color: 'var(--color-fg-subtle)',
                      letterSpacing: '0.05em',
                    }}
                  >
                    {s.authors}
                  </div>
                </div>

                <div className="lume-stack lume-stack-sm">
                  <h3 className="lume-h3" style={{ fontSize: '1.05rem' }}>{s.title}</h3>
                  {s.journal ? (
                    <p style={{ margin: 0, fontSize: '0.85rem', color: 'var(--color-fg-subtle)' }}>
                      {s.journal}
                      {s.doi ? (
                        <>
                          {' · '}
                          <a
                            href={`https://doi.org/${s.doi}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: 'var(--color-brand-700)' }}
                          >
                            {s.doi}{' '}
                            <ExternalLink size={12} aria-hidden="true" style={{ display: 'inline' }} />
                          </a>
                        </>
                      ) : null}
                    </p>
                  ) : null}
                  <p
                    style={{
                      margin: 0,
                      padding: '0.75rem 1rem',
                      background: 'var(--color-bg-muted)',
                      borderLeft: '3px solid var(--color-warm-500)',
                      borderRadius: '0 0.5rem 0.5rem 0',
                      fontSize: '0.92rem',
                      color: 'var(--color-fg-default)',
                      lineHeight: 1.55,
                    }}
                  >
                    <strong>Aplicação no Lume:</strong> {s.application}
                  </p>
                </div>
              </div>
            </motion.li>
          ))}
        </motion.ol>
      </div>
    </section>
  );
}
